import { render } from "./index.vue?vue&type=template&id=b52302dc&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=b52302dc&lang=less&scoped=true"
import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52302dc"]])

export default __exports__